import { RecommendationStatus } from "../infrastructure/enums/meta-data-field.enum";

export const RECOMMENDATION_JOB_STATUS_SELECTS = [
    {
        label: 'Done',
        value: RecommendationStatus.DONE,
        theme: 'success'
    },
    {
        label: 'Working',
        value: 'WORKING',
        theme: 'primary'
    },
    {
        label: 'None',
        value: RecommendationStatus.NONE,
        theme: 'secondary'
    },
    {
        label: 'Failed',
        value: RecommendationStatus.FAILED,
        theme: 'error'
    },
    {
        label: 'Invalid',
        value: RecommendationStatus.INVALID,
        theme: 'error'
    },
]